import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import classes from "./homeSection.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookingsByFilter } from "../../../../redux/slices/bookingSlice";
import { fetchTrendingArtists } from "../../../../redux/slices/artistSlice";
import { fetchParticipantsByCategory } from "../../../../redux/slices/andArenaSlice";
import { useNavigate } from "react-router-dom";

const HomeSection = ({ setActiveMenu }) => {
  const { bookings } = useSelector((state) => state.booking);

  const [upcomingBookings, setUpcomingBookings] = useState(bookings);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { trendingArtists } = useSelector((state) => state.artists);

  const [arenaArtists, setArenaArtists] = useState([]);

  const handleExploreFullArena = () => {
    navigate("/artist-next-door-arena");
  };

  const handleViewAllBookingsClick = () => {
    setActiveMenu("bookings");
  };

  useEffect(() => {
    dispatch(
      fetchBookingsByFilter({
        type: "user",
        status: "upcoming",
      })
    );
  }, [dispatch]);
  useEffect(() => {
    const options = ["singer", "musician", "rapper"];
    const randomOption = options[Math.floor(Math.random() * options.length)];
    dispatch(fetchTrendingArtists({}));
    dispatch(
      fetchParticipantsByCategory({
        category: randomOption,
        page_number: 1,
        page_size: 3,
      })
    );
  }, []);

  const formatDate = (dateString) => {
    const options = { weekday: "short", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const handleVote = (artistId) => {
    setArenaArtists((artists) =>
      artists.map((artist) => {
        if (artist.id === artistId && !artist.hasVoted) {
          return { ...artist, votes: artist.votes + 1, hasVoted: true };
        }
        return artist;
      })
    );
  };

  return (
    <div className={classes.dashboardContainer}>
      <div className={classes.dashboardHeader}>
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className={classes.welcomeTitle}
        >
          Welcome to ArtistNextDoor
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className={classes.welcomeSubtitle}
        >
          Discover, connect, and create with local artists
        </motion.p>
      </div>

      <div className={classes.dashboardContent}>
        <motion.section
          className={classes.upcomingBookingsSection}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2>Your Upcoming Bookings</h2>
          <div className={classes.upcomingBookingsList}>
            {upcomingBookings.length > 0 ? (
              upcomingBookings.map((booking, index) => (
                <motion.div
                  key={booking.id}
                  className={classes.bookingCard}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  whileHover={{
                    scale: 1.03,
                    boxShadow:
                      "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
                  }}
                >
                  <img
                    src={booking.image}
                    alt={booking.title}
                    className={classes.bookingImage}
                  />
                  <div className={classes.bookingDetails}>
                    <h3>{booking.title}</h3>
                    <p>with {booking.artist}</p>
                    <p className={classes.bookingDate}>
                      {formatDate(booking.date)} • {booking.time}
                    </p>
                  </div>
                  <motion.button
                    className={classes.viewDetailsBtn}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    View
                  </motion.button>
                </motion.div>
              ))
            ) : (
              <p className={classes.emptyState}>
                No upcoming bookings. Ready to explore some art?
              </p>
            )}
            <motion.button
              className={classes.viewAllBtn}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleViewAllBookingsClick}
            >
              View All Bookings
            </motion.button>
          </div>
        </motion.section>

        {/* Trending Artists Section */}
        <motion.section
          className={classes.trendingArtistsSection}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <h2>Trending Artists</h2>
          <div className={classes.trendingArtistsGrid}>
            {trendingArtists.map((artist, index) => (
              <motion.div
                key={artist.id}
                className={classes.artistCard}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.2, delay: 0.1 + index * 0.1 }}
                whileHover={{
                  scale: 1.05,
                  boxShadow:
                    "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
                }}
              >
                <div className={classes.artistImageContainer}>
                  <img
                    src={
                      artist.profile_picture ||
                      "https://firebasestorage.googleapis.com/v0/b/tech-jupyter.appspot.com/o/final_logo.png?alt=media&token=c2878f27-21b2-4bfb-936d-05793c4cc395"
                    }
                    alt={artist.first_name}
                    className={classes.artistImage}
                  />
                </div>
                <div className={classes.artistDetails}>
                  <h3>{artist?.first_name + " " + artist?.last_name || ""}</h3>
                  <p className={classes.artistSpecialty}>{artist.specialty}</p>
                  <div className={classes.artistStats}>
                    <span className={classes.rating}>★ {artist.rating}</span>
                    <span className={classes.bookingCount}>
                      {artist?.bookings ||
                        Math.ceil(Math.random(10, 50) * 100) +
                          "+ Bookings"}{" "}
                    </span>
                  </div>
                  <motion.button
                    className={classes.exploreBtn}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Explore
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.section>

        <motion.section
          className={classes.arenaSection}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <div className={classes.arenaHeader}>
            <h2>ArtistNextDoor Arena</h2>
            <motion.span
              className={classes.arenaBadge}
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
            >
              LIVE
            </motion.span>
          </div>
          <p className={classes.arenaDescription}>
            Vote for your favorite artists in this month's competition!
          </p>

          <div className={classes.arenaArtistsList}>
            {arenaArtists.map((artist, index) => (
              <motion.div
                key={artist.id}
                className={classes.arenaArtistCard}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 + index * 0.1 }}
                whileHover={{ scale: 1.03 }}
              >
                <img
                  src={artist.image}
                  alt={artist.name}
                  className={classes.arenaArtistImage}
                />
                <div className={classes.arenaArtistDetails}>
                  <p className={classes.artistArenaArtistNameTxt}>
                    {artist.name}
                  </p>
                  <p>{artist.specialty}</p>
                  <div className={classes.voteInfo}>
                    <motion.div
                      className={classes.voteCount}
                      animate={{ scale: artist.hasVoted ? [1, 1.2, 1] : 1 }}
                      transition={{ duration: 0.5 }}
                    >
                      {artist.votes} votes
                    </motion.div>
                    <motion.button
                      className={`${classes.voteButton} ${
                        artist.hasVoted ? classes.votedButton : ""
                      }`}
                      onClick={() => handleVote(artist.id)}
                      disabled={artist.hasVoted}
                      whileHover={{ scale: artist.hasVoted ? 1 : 1.1 }}
                      whileTap={{ scale: artist.hasVoted ? 1 : 0.95 }}
                    >
                      {artist.hasVoted ? "Voted" : "Vote"}
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.button
            className={classes.viewArenaBtn}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleExploreFullArena}
          >
            Explore Full Arena
          </motion.button>
        </motion.section>
      </div>
    </div>
  );
};

export default HomeSection;
